export default "__VITE_ASSET__D2aJ1wYt__"